import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { HeaderService } from '../../../../services/header.service';
import { TransactionsService } from 'src/app/services/transactions.service';
import { takeWhile } from 'rxjs';

@Component({
  selector: 'app-header-mobile',
  templateUrl: './header-mobile.component.html',
  styleUrls: ['./header-mobile.component.scss']
})
export class HeaderMobileComponent implements OnInit, OnDestroy {
  isInAMiddleOfScroll = this.headerService.isInAMiddleOfScroll;
  scrollHeight = this.headerService.scrollHeight;
  @Input() menuItems: Array<any>;
  currentPath = '';
  productDetailStartPath = 'p/product';
  trnsItems = [];
  private _isComponentActive  = true;
  constructor(
    public headerService: HeaderService,
    private _transactionsService: TransactionsService
    ) {
    this.currentPath =  window.location.pathname;
     this._transactionsService
     .clientTransactionsView$
     .pipe(takeWhile(()=>this._isComponentActive))
     .subscribe(transactions=>{
      this.trnsItems = transactions;
    });
  }
  

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this._isComponentActive = false;
  }

}
